export function trimLongText(text, maxCharPerLine, maxLines) {
  if (text.length <= maxCharPerLine) {
    // text is fine; do nothing
    return text;
  }

  const words = text.split(' ');

  if (words.length === 1 || words[0].length > maxCharPerLine) {
    // shortens single word string ie. supercalifragilisticexpi...
    return `${text.substring(0, maxCharPerLine - 1)}...`;
  }

  let fitText = words[0];
  // insert as many words as possible before ellipsis
  let lineChars = words[0].length;
  let line = 1;
  for (let i = 1; i < words.length; i += 1) {
    if (words[i].length <= (maxCharPerLine - lineChars)) {
      lineChars += (words[i].length + 1);
      fitText = `${fitText} ${words[i]}`;
    } else {
      lineChars = words[i];
      line += 1;
      if (line > maxLines) {
        break;
      } else {
        fitText = `${fitText} ${words[i]}`;
      }
    }
  }

  if (text.length > fitText.length) {
    fitText = `${fitText}...`;
  }

  return fitText;
}
